import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { graphql } from '@apollo/client/react/hoc';
import { common } from '../../../gql/common';
import useGa from '../../../hooks/ga';

const Header = loadable(p => import(`@quikr/ui/theme/${p.host}/components/Header`));
const Hamburger = loadable(() => import('../Hamburger'), { ssr: false });

const HeaderWrapper = props => {
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [links, setLinks] = useState({
    called: false,
    links: [],
    error: {}
  });
  const {
    data,
    data: { loading },
    host
  } = props;
  let showShare = true;
  if (loading) return null;

  const { isMobile, user } = data;
  const loggedIn = Boolean(user);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  if (pathname === '/post-ad') {
    showShare = false;
  }

  return (
    <>
      <Header
        isMobile={isMobile}
        pageType="Landing"
        toggleMenu={toggleMenu}
        loggedIn={loggedIn}
        useGa={useGa}
        userObj={user}
        host={host}
        showShare={showShare}
        logoutAction={false}
      />
      {isMenuOpen && (
        <Hamburger
          loggedIn={loggedIn}
          userObj={user}
          isMobile={isMobile}
          toggleMenu={toggleMenu}
          host={host}
          show={isMenuOpen}
          links={links}
          handleLinks={setLinks}
        />
      )}
    </>
  );
};

HeaderWrapper.propTypes = {
  data: PropTypes.object,
  host: PropTypes.string
};

export default graphql(common)(HeaderWrapper);
